/* eslint-disable @atlaskit/design-system/no-emotion-primitives */
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */
/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@emotion/react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { type ColorTokenCategoryProps } from './color';

const spaceWidthStyles = xcss({
	width: 'size.600',
});

const negativeSpaceStyles = xcss({
	border: `2px dotted ${token('color.border.accent.purple')}`,
});

export const Space = ({ value }: ColorTokenCategoryProps): React.JSX.Element => {
	const isNegative = value[0] === '-';

	return (
		<Box paddingInline="space.050" xcss={spaceWidthStyles}>
			<Box
				backgroundColor={isNegative ? undefined : 'color.background.accent.purple.subtle'}
				xcss={isNegative ? negativeSpaceStyles : undefined}
				style={{
					width: isNegative ? value.slice(1) : value,
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
					height: '24px',
				}}
			/>
		</Box>
	);
};
